import { Action, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BaseCalendarEventFragment,
  BaseFieldFragment,
  Charge,
  CreateCalendarEventInput,
  CreateChargeInput,
  CreateDiscountInput,
  Discount,
  Expense,
  FullJobFragment,
  ItineraryItem,
  JobDetailsV2Fragment,
  SelectedProduct,
  Tax
} from 'graphql.generated';

import { EventWithCharges } from 'src/app/estimates/estimate-confirmation/estimate-confirmation.component';

import {
  CalendarEventWithLockedAndInvoicedFlag,
  ChargesUpdate,
  CommentChange,
  SummaryUpdate,
  UnsavedChangesToastInfo,
} from '../../jobv2-create/jobv2-interfaces';

type DocumentType = 'estimate' | 'all-documents' | 'invoice';

export const WorkOrdersActions = createActionGroup({
  source: 'Work Orders',
  events: {
    'Fill Out Events With Charges': props<{
      calculatedEvents: EventWithCharges[];
    }>(),

    'Add Charges Clicked': props<{
      eventId: string;
    }>(),
    'Add Discounts Clicked': props<{
      eventId: string;
    }>(),
    'Add Charges Closed': emptyProps(),
    'Add Discounts Closed': emptyProps(),

    'Taxes Loaded': props<{ taxes: Tax[] }>(),
    'Expenses Loaded': props<{ expenses: Expense[] }>(),

    'Available Discounts Loading': emptyProps(),
    'Available Discounts Loaded Success': props<{
      discounts: Partial<Discount>[];
    }>(),
    'Available Discounts Loaded Error': props<{ error: Error }>(),

    'Product For Adding Selected': props<{
      productId: string;
      priceId: string;
      quantity: number;
    }>(),
    'Add Charges Saved': emptyProps(),

    'Existing Charges Updated': props<{
      chargeId?: string;
      quantity?: number;
      amount?: number;
      eventId?: string;
      removed?: boolean;
      orderUpdatedInput?: {
        targetEvent: Partial<CalendarEventWithLockedAndInvoicedFlag>;
        insertedCharge: Charge;
        insertedChargeIndex: number;
        isInsertedChargeNew?: boolean;
        donorEvent?: Partial<CalendarEventWithLockedAndInvoicedFlag>;
      }
    }>(),
    'Changes Saved Success': props<{
        updatedJob: JobDetailsV2Fragment,
        originalAction: Action,
        mutationId?: string,
    }>(),
    'Changes Saved Error': props<{
        error: Error,
        mutationId?: string,
    }>(),
      'Save Button Clicked': emptyProps(),
      'Cancel button Clicked': props<{ eventId?: string }>(),
      'changes Saved Initiated': props<{
         mutationId?: string;
      }>(),
      'Changes Saved No Changes': props<{
         originalAction: Action,
         //when changes recorded, should not be saved but should be removed from state and ls
         //e.g. charge was added and removed before saving and it was the only one change
         clearRecorderChanges?: boolean,
      }>(),

    'Add Discount': props<{
      discounts: Array<{
        discountId: string;
        eventId: string;
        customAmount?: number;
      }>;
    }>(),

    'Remove Discount': props<{
      appliedId: string;
    }>(),

    'Create Single Use Discount': props<{
      createDiscountInput: CreateDiscountInput;
      eventsIds: string[];
    }>(),

    'Create Custom Charge Clicked': emptyProps(),
    'Close Custom Charge Dialog Clicked': emptyProps(),

    'Create Custom Charge': props<{
      createChargeInput: CreateChargeInput;
      userId: string; //job customer id
    }>(),

    'Apply Unsaved Changes From LS': props<{
      unsavedChanges: ChargesUpdate[];
      unsavedSummaryChanges: SummaryUpdate[];
      unsavedCommentChanges: CommentChange[];
    }>(),
    'Generate Unsaved Changes Toasts': props<{
      unsavedChangesToastsInfo: UnsavedChangesToastInfo[];
    }>(),
    'Update Charges Order': props<{
      targetEvent: Partial<CalendarEventWithLockedAndInvoicedFlag>;
      insertedCharge: Charge;
      insertedChargeIndex: number;
      isInsertedChargeNew?: boolean;
      donorEvent?: Partial<CalendarEventWithLockedAndInvoicedFlag>;
    }>(),

    'Create Event': props<{ eventInput: CreateCalendarEventInput }>(),

    'Duplicate Event': props<{
      eventInput: Partial<CalendarEventWithLockedAndInvoicedFlag>;
    }>(),

    'Cancel Event': props<{ eventId: string }>(),

    'Delete Event': props<{ eventId: string }>(),

    'Reorder Events': props<{
      eventsWithNewOrder: { eventId: string; newOrder: number }[];
    }>(),

    'Work Order Unsaved Changes Dumped to LS': emptyProps(),

    'Add Document Button Clicked': props<{ createDocument: DocumentType }>(),

    'Generate Charges With AI': props<{ eventId: string }>(),
      'Regenerate Charges With AI': props<{ eventId: string }>(),
      'Open Charges Generated With AI Summary': props<{ eventId: string, }>(),
      'Generate Charges With AI Success': props<{
         eventId: string,
         selectedProducts: SelectedProduct[],
         agentInstructions: string,
         itinerary: ItineraryItem[];
         crewSize: number;
      }>(),
      'Generate Charges With AI Error': props<{ error: Error }>(),

      'Promote Event Button Clicked': props<{ event: BaseCalendarEventFragment }>(),
      'Promote Event Success': props<{ eventId: string, status: string }>(),
      'Promote Event Error': props<{ error: Error }>(),
      'Event Selected From Suggestions': props<{ ids: string[] }>(),
    },
  },
);
